module.exports = "/_next/static/media/1177c852d15ed67bc020a642aaa980eb.png";